export default "__VITE_ASSET__CAuQ1ijN__"